import React from 'react';
import { Container, Row, Col, Image } from "react-bootstrap";
import IntroImage from '../../assets/images/banners/AboutUs.png';
import WhyUsImage from '../../assets/images/banners/why-us.png';
import EvaluationMethodImage from '../../assets/images/banners/evaluation-method.png';
import SupervisionImage from '../../assets/images/banners/supervision.png';

import './about.module.css';

const AboutPage = props => {
    return (
        <div>
            <Image styleName="intro-image" className="d-block mx-auto w-100" src={IntroImage} />
            <section styleName="about-intro-section">
                <Container>
                    <Row>
                        <Col xs={12} className="mt-4">
                            <p className="text-left mt-4" styleName="intro-title">সুপ্রিয় শিক্ষার্থীরা,</p>
                            <p className="text-left mt-4" styleName="intro-title">আস্সালামু আলাইকুম।</p>
                            <div styleName="intro-content">
                                <p>
                                    যন্ত্রণাকাতর মুমূর্ষের মুখে হাসি ফোটানোর মহান প্রত্যয় নিয়ে তোমরা যারা ডাক্তার হবার বাসনা মনে
                                    লালন করছ, তোমাদেরকে ঐতিহ্যবাহী, অপ্রতিদ্বন্দ্বী ও শীর্ষস্থানীয় “ রেটিনা মেডিকেল ও ডেন্টাল
                                    ভর্তি কোচিং” এর পক্ষ থেকে জানাচ্ছি আন্তরিক শুভেচ্ছা। দীর্ঘ বার বছরে তোমাদের যে কঠোর পরিশ্রম,
                                    মেধার অনুশীলন আর দুর্নিবার স্বপ্ন দেখার যে প্রয়াস, তারই মূল্যায়ন হবে এবার। জীবন সংগ্রামের
                                    সবচেয়ে কঠিন, ভয়ংকর আর পিচ্ছিল ধাপে অবতীর্ণ হতে যাচ্ছ তোমরা। কারণটি দিবালোকের মত পরিষ্কার। ৩৬
                                    টি সরকারী মেডিকেল ও ৯ টি ডেন্টাল কলেজের মোট ৪৬০০ টি আসনের জন্য প্রতিবছর প্রায় ৮০ হাজারেরও
                                    অধিক ছাত্র-ছাত্রী ভর্তি যুদ্ধে অংশগ্রহণ করে। এত বিপুল সংখ্যক ছাত্র-ছাত্রীর মধ্যে মাত্র ৫-৬%
                                    তাদের অভীষ্ট লক্ষ্যে পৌঁছতে পারে। বাকিরা ছিটকে পড়ে নিরুদ্দেশে। এই কঠিন প্রতিযোগিতা আর
                                    প্রতিকূলতার মাঝে তোমাদের পাশে একমাত্র নির্ভরযোগ্য দিক নির্দেশনার যে আলোকবর্তিকা, তার নাম
                                    রেটিনা।
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section styleName="why-us-section">
                <Container>
                    <Row>
                        <Col className="align-self-center text-center" xs={12} md={6}>
                            <Image style={{ maxHeight: 320 }} className="img-fluid" src={WhyUsImage} />
                        </Col>

                        <Col className="align-self-center" xs={12} md={6}>
                            <div styleName="about-content">
                                <h2>আমাদের স্বাতন্ত্র্য</h2>
                                <ul>
                                    <li>সরাসরি পাঠ্য বই থেকে পাঠ দান, শুধু লেকচার শীট বা নোট কেন্দ্রিক প্রস্তুতি নয়।</li>
                                    <li>প্রতিটি বিষয় ২/৩ টি বই থেকে লাল সবুজ কালিতে দাগিয়ে সব গুরুত্বপূর্ণ তথ্য নিশ্চিত করা।</li>
                                    <li>বেসিক কনসেপসন গঠনের জন্য মাল্টিমিডিয়া প্রেজেন্টেশন সমৃদ্ধ লেকচার ক্লাস।</li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section styleName="evaluation-method-section">
                <Container>
                    <Row>
                        <Col className="align-self-center" xs={12} md={6}>
                            <div styleName="about-content">
                                <h2>মূল্যায়ন পদ্ধতিঃ</h2>
                                <ul>
                                    <li>সরাসরি পাঠ্য বই থেকে পাঠ দান, শুধু লেকচার শীট বা নোট কেন্দ্রিক প্রস্তুতি নয়।</li>
                                    <li>প্রতিটি বিষয় ২/৩ টি বই থেকে লাল সবুজ কালিতে দাগিয়ে সব গুরুত্বপূর্ণ তথ্য নিশ্চিত করা।</li>
                                    <li>বেসিক কনসেপসন গঠনের জন্য মাল্টিমিডিয়া প্রেজেন্টেশন সমৃদ্ধ লেকচার ক্লাস।</li>
                                </ul>
                            </div>
                        </Col>
                        <Col className="align-self-center text-center" xs={12} md={6}>
                            <Image style={{ maxHeight: 320 }} className="img-fluid" src={EvaluationMethodImage} />
                        </Col>
                    </Row>
                </Container>
            </section>

            <section styleName="supervision-section">
                <Container>
                    <Row>
                        <Col className="align-self-center text-center" xs={12} md={6}>
                            <Image style={{ maxHeight: 320 }} className="img-fluid" src={SupervisionImage} />
                        </Col>
                        <Col className="align-self-center" xs={12} md={6}>
                            <div styleName="about-content">
                                <h2>তত্ত্বাবধানঃ</h2>
                                <ul>
                                    <li>সরাসরি পাঠ্য বই থেকে পাঠ দান, শুধু লেকচার শীট বা নোট কেন্দ্রিক প্রস্তুতি নয়।</li>
                                    <li>প্রতিটি বিষয় ২/৩ টি বই থেকে লাল সবুজ কালিতে দাগিয়ে সব গুরুত্বপূর্ণ তথ্য নিশ্চিত করা।</li>
                                    <li>বেসিক কনসেপসন গঠনের জন্য মাল্টিমিডিয়া প্রেজেন্টেশন সমৃদ্ধ লেকচার ক্লাস।</li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </div>
    )
}

export default AboutPage;